module.exports = __webpack_public_path__ + "static/img/4013.2878b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4013.png
// module id = 720
// module chunks = 0 1 12